import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PageResult, PaginationParameters } from '../../types';
import {
  Glossary,
  GlossaryPost,
  GlossaryPublish,
  GlossaryUpdate,
} from './types';
import { DateTime } from 'luxon';
import { ErrorService } from '../../error';
import { catchError } from 'rxjs/operators';
import { MessageService } from '../../service/message/message.service';
import { CrudType } from '../../service/message/types';

@Injectable({
  providedIn: 'root',
})
export class GlossaryApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: string): Observable<Glossary> => {
    let parameters: string[];
    parameters = [id];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<Glossary>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  postGlossary = (glossaryPost: GlossaryPost): any => {
    let parameters: string[];
    parameters = [];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .post<Glossary>(url, glossaryPost, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  publishGlossary = (id: string): any => {
    let parameters: string[];
    parameters = ['publish', id];
    let url = this.formatUrl(parameters);
    let glossaryPut: GlossaryPublish = {
      publicationDate: DateTime.utc(),
    };
    return this.httpClient.put<Glossary>(url, glossaryPut).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  unpublishGlossary = (id: string): any => {
    let parameters: string[];
    parameters = ['unpublish', id];
    let url = this.formatUrl(parameters);
    return this.httpClient.put<Glossary>(url, '').pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  updateGlossary = (glossaryUpdate: GlossaryUpdate): any => {
    var parameters: string[];
    parameters = [glossaryUpdate.id];
    var url = this.formatUrl(parameters);
    return this.httpClient
      .put<Glossary>(url, glossaryUpdate, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.glossaries.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
